import { type ComponentProps, memo } from 'react'

import View from './Modal.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function ModalController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Modal_Controller'

export default Controller
